package com.tixforgigs.common.core.util

import com.tixforgigs.common.core.enums.ClientType
import com.tixforgigs.common.core.extensions.BuildKonfigUtil
import com.tixforgigs.common.core.imports.BrowserConfig
import com.tixforgigs.common.core.imports.Faro
import com.tixforgigs.common.core.imports.getWebInstrumentations
import com.tixforgigs.common.core.imports.initializeFaro
import com.tixforgigs.common.http.HttpClient
import js.objects.unsafeJso

object FaroUtil {

  private const val FARO_URL = "https://faro.monitoring.tixforgigs.dev/collect"

  private var faro: Faro? = null

  fun init() {
    if (faro != null) return

    val config: BrowserConfig = unsafeJso {
      app = unsafeJso {
        name = appName()
        version = BuildKonfigUtil.CLIENT_VERSION
        namespace = appNamespace()
        release = BuildKonfigUtil.CLIENT_VERSION
        environment = HttpClient.FLAVOR.value
        bundleId = bundleId()
      }
      url = FARO_URL
      instrumentations = getWebInstrumentations(
        unsafeJso {
          captureConsole = false
          enablePerformanceInstrumentation = false
        }
      )
    }

    faro = initializeFaro(config)
  }

  fun captureException(
    error: Throwable,
    type: String? = null,
    context: Map<String, String> = emptyMap(),
  ) {
    val faro = instance() ?: return

    faro.api.pushError(
      error,
      unsafeJso {
        if (type != null) {
          this.type = type
        }
        if (context.isNotEmpty()) {
          this.context = context.toJsObject()
        }
      }
    )
  }

  fun captureMessage(
    message: String,
    level: String? = null,
    context: Map<String, String> = emptyMap(),
  ) {
    val faro = instance() ?: return

    faro.api.pushLog(
      arrayOf(message),
      unsafeJso {
        this.level = faroLogLevel(level)
        if (context.isNotEmpty()) {
          this.context = context.toJsObject()
        }
      }
    )
  }

  private fun instance(): Faro? {
    if (faro == null) {
      init()
    }
    return faro
  }

  private fun appName() = when (HttpClient.CLIENT_TYPE) {
    ClientType.ARAI_STOREFRONT -> "storefront"
    ClientType.TEMPLATE_CONFIGURATOR -> "configurator"
  }

  private fun appNamespace() = when (HttpClient.CLIENT_TYPE) {
    ClientType.ARAI_STOREFRONT -> "arai:storefront"
    ClientType.TEMPLATE_CONFIGURATOR -> "arai:configurator"
  }

  private fun bundleId() = when (HttpClient.CLIENT_TYPE) {
    ClientType.ARAI_STOREFRONT -> "com.tixforgigs.arai.storefront"
    ClientType.TEMPLATE_CONFIGURATOR -> "com.tixforgigs.arai.configurator"
  }

  private fun faroLogLevel(level: String?) = when (level?.lowercase()) {
    "trace" -> "trace"
    "debug" -> "debug"
    "warn", "warning" -> "warn"
    "error", "fatal" -> "error"
    else -> "info"
  }

  private fun Map<String, String>.toJsObject(): dynamic {
    val obj = unsafeJso<dynamic> {}
    forEach { (key, value) ->
      obj.asDynamic()[key] = value
    }
    return obj
  }

//  launch {
//    // todo: configure otel server
//    val otel = Otel.sdk
//    val logger = otel.loggerProvider.getLogger(BuildKonfig.APP_NAME, BuildKonfigUtil.CLIENT_VERSION)
//    exampleLogs(logger)
//    val tracer = otel.tracerProvider.getTracer(BuildKonfig.APP_NAME, BuildKonfigUtil.CLIENT_VERSION)
//    exampleTraces(tracer)
//  }
}
